export const QUERY_UPDATE_ENTITIES = '@@tbx-query/updateEntities/UPDATE_ENTITIES';
export const TRANSFORM_ENTITIES = '@@tbx-query/transformEntities/TRANSFORM_ENTITIES';
export const BOOTSTRAP_LOADING = '@@tbx-query/bootstrapLoading/BOOTSTRAP_LOADING';
export const BOOTSTRAP_LOADED = '@@tbx-query/bootstrapLoaded/BOOTSTRAP_LOADED';
